var React = require('react');
var Geocoder = require('react-select-geocoder');

var Entry = require("./Entry");

var NewEntryForm = React.createClass({displayName: "NewEntryForm",

    getInitialState: function() {
        return {
            requestState: 'notSent',
            pullRequestUrl: '',
            err: ''
        };
    },

    componentDidUpdate: function() {
        componentHandler.upgradeDom();
    },

    componentDidMount: function() {
        componentHandler.upgradeDom();
    },

    submitForm: function() {
        var entry = new Entry({
            "lat": this.refs.lat.value,
            "lng": this.refs.lng.value,
            "title": this.refs.title.value,
            "description": this.refs.description.value,
            "symbol": this.refs.radio_startup.checked ? this.refs.radio_startup.value : this.refs.radio_job.value
        });

        var data = {
            entry       : entry,
            callback    : this.onPullRequestReady
        };

        console.info(data);
        this.setState({
            requestState: 'loading'
        });
        this.props.postNewEntry(data);
    },

    getUserLocation: function() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.setLocation);
        } else {
            this.setState({
                requestState: 'error',
                err: 'Geolocation is not supported by this browser.'
            });
        }
    },

    getSelectedLocation: function(position){
        this.setLocation({
            coords :{
                longitude: Number(position.geometry.coordinates[0]),
                latitude: Number(position.geometry.coordinates[1])
            }
        });
    },

    setLocation: function(position) {
        document.getElementById("lat_input").value = position.coords.latitude.toFixed(3);
        document.getElementById("lat_div").className += " is-dirty";

        document.getElementById("lng_input").value = position.coords.longitude.toFixed(3);
        document.getElementById("lng_div").className += " is-dirty";
        componentHandler.upgradeDom();
    },

    onPullRequestReady: function(data) {
        if (data.err) {
            this.setState({
                requestState: 'error',
                err: data.err
            });
        } else {
            this.setState({
                requestState: 'ready',
                pullRequestUrl: data.pullRequestUrl
            });
        }
    },

    render: function() {

        if (!this.props.isTokenReady() && !this.props.isUrlWithCode()){
            return (
                React.createElement("div", null, 
                    React.createElement("a", {href: "https://github.com/login/oauth/authorize?client_id=7c710fb3bcb9805f7c3a&scope=public_repo"}, 
                        "First, allow me to fork this repository for you."
                    )
                )
            );
        }

        return (
            React.createElement("div", null, 
                React.createElement("form", null, 

                    React.createElement("h6", null, "Position Details"), 
                    React.createElement("div", {className: "mdl-textfield mdl-js-textfield"}, 
                        React.createElement("input", {className: "mdl-textfield__input", type: "text", id: "title", ref: "title"}), 
                        React.createElement("label", {className: "mdl-textfield__label", htmlFor: "title"}, "Title")
                    ), 

                    React.createElement("div", null, 

                        React.createElement(Geocoder, {apiKey: 'search-WPgeBUE', placeholder: 'Select Location', 
                                  onChange: this.getSelectedLocation}), 

                        React.createElement("div", {style: {display: 'table-cell'}}, 
                            React.createElement("div", {className: "mdl-textfield mdl-js-textfield", style: {width: '100px'}, 
                                 id: "lat_div"}, 
                                React.createElement("input", {className: "mdl-textfield__input", type: "text", id: "lat_input", 
                                       pattern: "-?[0-9]*(\\.[0-9]+)?", ref: "lat"}), 
                                React.createElement("label", {className: "mdl-textfield__label", htmlFor: "lat_input"}, "Latitude"), 
                                React.createElement("span", {className: "mdl-textfield__error"}, "Input is not a number!")
                            ), 
                            React.createElement("div", {className: "mdl-textfield mdl-js-textfield", style: {width: '100px'}, 
                                 id: "lng_div"}, 
                                React.createElement("input", {className: "mdl-textfield__input", type: "text", id: "lng_input", 
                                       pattern: "-?[0-9]*(\\.[0-9]+)?", ref: "lng"}), 
                                React.createElement("label", {className: "mdl-textfield__label", htmlFor: "lng_input"}, "Longitude"), 
                                React.createElement("span", {className: "mdl-textfield__error"}, "Input is not a number!")
                            ), 

                            React.createElement("button", {className: "mdl-button mdl-js-button mdl-button--accent", 
                                    type: "button", onClick: this.getUserLocation}, 
                                "Use My Location"
                            )
                        )
                    ), 

                    React.createElement("div", {className: "mdl-textfield mdl-js-textfield", style: {width: '100%'}}, 
                        React.createElement("textarea", {className: "mdl-textfield__input", type: "text", rows: "4", id: "description", 
                                  ref: "description"}
                        ), 
                        React.createElement("label", {className: "mdl-textfield__label", htmlFor: "description"}, "Job Desciption")
                    ), 

                    React.createElement("div", null, 
                        React.createElement("label", {className: "mdl-radio mdl-js-radio mdl-js-ripple-effect", 
                               htmlFor: "radio_startup", style: {margin: '10px'}}, 
                            React.createElement("input", {type: "radio", id: "radio_startup", defaultChecked: true, 
                                   className: "mdl-radio__button", name: "options", 
                                   ref: "radio_startup", value: "rocket"}), 
                            React.createElement("span", {className: "mdl-radio__label"}, "Startup")
                        ), 
                        React.createElement("label", {className: "mdl-radio mdl-js-radio mdl-js-ripple-effect", 
                               htmlFor: "radio_job"}, 
                            React.createElement("input", {type: "radio", id: "radio_job", 
                                   className: "mdl-radio__button", name: "options", 
                                   ref: "radio_job", value: "clothing-store"}), 
                            React.createElement("span", {className: "mdl-radio__label"}, "Job Seeker")
                        )
                    )

                ), 
                React.createElement("button", {className: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored", 
                        disabled: this.state.requestState == 'loading' || this.state.requestState == 'ready', 
                        onClick: this.submitForm}, 
                    "Publish"
                ), 

                (function(state) {
                    if (!state.requestState) {
                        return (React.createElement("div", null));
                    } else if (state.requestState == 'loading') {
                        return (
                            React.createElement("div", null, 
                                React.createElement("br", null), 
                                React.createElement("div", {className: "mdl-progress mdl-js-progress mdl-progress__indeterminate", 
                                     style: {width: '100%'}})
                            ));
                    } else if (state.requestState == 'ready') {
                        return (React.createElement("div", null, React.createElement("a", {href: state.pullRequestUrl}, "Track your submission")));
                    } else if (state.requestState == 'error') {
                        return (React.createElement("div", null, state.err));
                    }
                })(this.state)

            )
        );
    }
});

module.exports = NewEntryForm;


/** WEBPACK FOOTER **
 ** ./NewEntryForm.js
 **/